var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9172 11.6667H12.2589L12.0255 11.4417C13.0255 10.275 13.5422 8.68337 13.2589 6.9917C12.8672 4.67503 10.9339 2.82503 8.60052 2.5417C5.07552 2.10837 2.10885 5.07503 2.54219 8.60003C2.82552 10.9334 4.67552 12.8667 6.99219 13.2584C8.68386 13.5417 10.2755 13.025 11.4422 12.025L11.6672 12.2584V12.9167L15.2089 16.4584C15.5505 16.8 16.1089 16.8 16.4505 16.4584C16.7922 16.1167 16.7922 15.5584 16.4505 15.2167L12.9172 11.6667ZM7.91719 11.6667C5.84219 11.6667 4.16719 9.9917 4.16719 7.9167C4.16719 5.8417 5.84219 4.1667 7.91719 4.1667C9.99219 4.1667 11.6672 5.8417 11.6672 7.9167C11.6672 9.9917 9.99219 11.6667 7.91719 11.6667Z",
    fill: "#0BA9F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlueIcon);
export default __webpack_public_path__ + "static/media/search-blue-icon.1564e1b09df6e6e1463315bd2ea52fb9.svg";
export { ForwardRef as ReactComponent };